var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "offering-options-summary-toolbar-view",
      class: {
        "offering-options-summary-toolbar-view-only-summary":
          _vm.onlySummary || _vm.noOfferingOptions,
      },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        { staticClass: "offering-options-summary-toolbar-view-container" },
        [
          _vm.onlyOfferingName || _vm.noOfferingOptions || _vm.isSingleOption
            ? [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "offerings:" + _vm.internalValue.id + ".name",
                        _vm.internalValue.name
                      )
                    )
                  ),
                ]),
                _c("divider", { staticClass: "divider" }),
              ]
            : _vm._e(),
          _vm._l(_vm.selectedOptionsFilteredToShow, function (option) {
            return !_vm.noOfferingOptions && !_vm.onlyOfferingName
              ? [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getOfferingOptionValueLabel(option.value))
                    ),
                  ]),
                  _c("divider", { staticClass: "divider" }),
                ]
              : _vm._e()
          }),
          _vm.showPricing &&
          (_vm.onlySummary || _vm.noOfferingOptions || _vm.isProjectSinglePage)
            ? [
                _c("PriceView", {
                  staticClass: "offering-options-price-view",
                  attrs: {
                    cents: _vm.offeringModelPrice,
                    currency: _vm.currencyModel
                      ? _vm.currencyModel.id
                      : undefined,
                  },
                }),
                _c("divider", { staticClass: "divider" }),
              ]
            : _vm._e(),
          !_vm.noOfferingOptions && !_vm.onlySummary
            ? _c("IconComponent", [_vm._v("drop_down")])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }